import { useDispatch, useSelector } from 'react-redux';
import FJAIPhotoEditorLeft from '../view/FJAIPhotoEditorLeft';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor';
import { useCallback, useMemo } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';
import { AI_PHOTO_EDITOR_MODELS } from '../../../../config/dataConfig/FJAIPhotoEditorData';

const FJAIPhotoEditorLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const taskStatus = useSelector(state => state.aiPhotoEditor.taskStatus);
    const freeNumCreation = useSelector(state => state.aiPhotoEditor.freeNumCreation);
    const isFree = useSelector(state => state.common.isFree);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const curModel = useSelector(state => state.aiPhotoEditor.curModel);
    const curResolution = useSelector(state => state.aiPhotoEditor.curResolution);
    const handleGenerate = useCallback(() => {
        dispatch(FJActionAIPhotoEditor.onGenerateAction());
    }, [dispatch]);

    // 根据当前模型判断是否支持多图上传
    const supportImageReferenceNum = useMemo(() => {
        const currentModel = AI_PHOTO_EDITOR_MODELS.find(item => item.value === curModel);
        return currentModel?.supportImageReferenceNum || 5;
    }, [curModel]);

    return (
        <FJAIPhotoEditorLeft
            onGenerate={handleGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            isFree={isFree}
            isProjectLoading={isProjectLoading}
            curModel={curModel}
            curResolution={curResolution}
            supportImageReferenceNum={supportImageReferenceNum}
        />
    );
};

export default FJAIPhotoEditorLeftContainer;
